exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-icon{\r\n  padding: 0px !important;\r\n  margin: 0px !important;\r\n  height: 1rem !important;\r\n  vertical-align: middle !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/packing-ec/packing-ec.component.css
// module id = ../../../../../src/app/components/packing-ec/packing-ec.component.css
// module chunks = main